module.exports = __webpack_public_path__ + "static/media/Hold Back the Sun.4563721f.jpg";